export const IMAGE_VERSION = 0.1;
export const TRANSLATIONS_KEY = 'translations';
export const TRACKING_ELEMENT_ID = 'track';
export const EVENT_TRACKING_KEY = 'track-event';
export const OPEN_MATCH_STATUS = '1';
export const LIVE_MATCH_STATUS = '2';
export const UPCOMING_MATCHES_STATUS = '0';
export const API_BACKDOOR_KEY = 'sanzensekai';
export const IMG_BASE_PATH = process.env.REACT_APP_IMAGE_PATH;
export const tourId = 1;
export const webviewParam = 'isWebView';
export const retValMessages = {
  createTeam: {
    1001: 'The match has been locked.',
    1002: 'The match has been locked for late-onboarded users.',
    401: 'Team already exists for a particular user.',
    402: 'The selected players have already been picked in the current phase.',
    20: 'User has picked an invalid number of players.',
    4: 'User has already created a team.',
    5: 'User has picked players with an invalid skill count.',
    6: 'User has picked duplicate players.',
    410: 'User updated with the same team.',
    5000: 'SP called on wrong shard.',
    5001: 'Team not found to update.',
    998: 'User has picked an invalid number of players.',
    404: 'Player already picked in the current phase.',
    '-4': 'Unknown Error in validation block.',
    '-1': 'Unknown Error.',
    '-2': 'Unknown Error in opt_type = 1.',
    '-3': 'Unknown Error in opt_type = 2.',
    1480: 'Gameday is abandoned, match status = 5.',
    201: 'User not found.'
  },
  success: {
    1: 'Team saved successfully.'
  }
};
